import { Component, OnInit } from '@angular/core';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { OffersImport } from '../../../../models/admModel/offer.model';
import { OffersService } from '../../../../shared/services/admServices/offers.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'import-offer-component',
  templateUrl: './import-offer-component.html',
  styleUrls: ['./import-offer-component.scss'],
})
export class importofferComponent implements OnInit {

  importData : OffersImport[] = [];
  ColumnMode = ColumnMode;
  dropdownListAdvertiser : any[] = [];
  selectedItemsAdvertiser : any[] = [];
  dropdownSettingsAdvertiser: any = {};

  constructor(private offersService: OffersService, private toastrService: ToastrService,) {
  }

  ngOnInit(): void {
    this.getImport();
    // dropdownlist ADVERTISER
    this.dropdownListAdvertiser = [
          { item_id: 1, item_text: 'AdGate' },
          { item_id: 2, item_text: 'Affluent' },
          { item_id: 3, item_text: 'Aragon' },
          { item_id: 4, item_text: 'ClickDealer' },
          { item_id: 5, item_text: 'Mapstreet' },
          { item_id: 6, item_text: 'PocketMedia' },
          { item_id: 7, item_text: 'SmartResponseMedia' },  //
          { item_id: 8, item_text: 'Vanelo' },  //
          { item_id: 9, item_text: 'OpinionSample' },
          { item_id: 10, item_text: 'Wdigital' },
          { item_id: 11, item_text: 'AdstartMedia' },
          { item_id: 12, item_text: 'Mobitka' } //
        ];
    this.selectedItemsAdvertiser=[];
    this.dropdownSettingsAdvertiser = {
          singleSelection: true,
          idField: "item_id",
          textField: "item_text",
          selectAllText: "Select All",
          unSelectAllText: "UnSelect All",
          itemsShowLimit: 1,
          allowSearchFilter: false,
          closeDropDownOnSelection: true
        };
  }

  getImport(){
    this.offersService.getImport()
    .subscribe(
    data => {
      this.importData = data.data;
    },
    error => {
      console.log(error);
    });
  }

  calculateDiff(sentOn){
    let today = new Date().toDateString();
    let t1 = new Date(today);
    let some = new Date(sentOn).toDateString();
    let t2 = new Date(some);

    let Time = t1.getTime() - t2.getTime();
    let Days = Time / (1000 * 3600 * 24); //Diference in Days

    return Math.floor(Days);
  }

  onItemSelectAdvertiser(item: any) {

  }

  onImport(){
    if(this.selectedItemsAdvertiser.length==0)
      this.toastrService.error('You have not selected an advertiser', 'Error !');
    else
    {
      this.offersService.importOffers(this.selectedItemsAdvertiser[0].item_id)
      .subscribe(
       data => {
        this.toastrService.success('Selected ' + this.selectedItemsAdvertiser[0].item_text + ` to import. Please wait for result`, 'Success !');
        this.toastrService.success( data.message, 'Success !');
      },
       error => {
         console.log(error);
       });
    }
  }

  onImportAll(){
    this.offersService.importAllOffers()
    .subscribe(
     data => {
      this.toastrService.success( data.message, 'Success !');
    },
     error => {
       console.log(error);
     });
  }

}
